import { useEffect, useState, useCallback } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

// Listens for a lightweight 'fly-to-cart' browser event and plays a short
// "item flies into the cart" animation. Only one temporary element exists
// per click, and it removes itself the moment the animation finishes -
// so this never adds ongoing weight to the page.
const FlyToCartLayer = () => {
  const [flyingItems, setFlyingItems] = useState([])

  const removeItem = useCallback((id) => {
    setFlyingItems((items) => items.filter((item) => item.id !== id))
  }, [])

  useEffect(() => {
    const handleFlyToCart = (e) => {
      const cartTarget = document.getElementById('cart-icon-target')
      if (!cartTarget) return

      const startRect = e.detail.startRect
      const endRect = cartTarget.getBoundingClientRect()

      const id = Date.now() + Math.random()
      setFlyingItems((items) => [
        ...items,
        {
          id,
          imageSrc: e.detail.imageSrc,
          startX: startRect.left + startRect.width / 2 - 28,
          startY: startRect.top + startRect.height / 2 - 28,
          endX: endRect.left + endRect.width / 2 - 28,
          endY: endRect.top + endRect.height / 2 - 28
        }
      ])
    }

    window.addEventListener('fly-to-cart', handleFlyToCart)
    return () => window.removeEventListener('fly-to-cart', handleFlyToCart)
  }, [])

  return (
    <div className="pointer-events-none fixed inset-0 z-[9999]">
      <AnimatePresence>
        {flyingItems.map((item) => (
          <motion.img
            key={item.id}
            src={item.imageSrc}
            alt=""
            className="w-14 h-14 object-cover rounded-full shadow-lg border-2 border-white"
            style={{ position: 'fixed', top: 0, left: 0 }}
            initial={{ x: item.startX, y: item.startY, scale: 1, opacity: 1 }}
            animate={{
              x: [item.startX, (item.startX + item.endX) / 2, item.endX],
              y: [item.startY, item.startY - 80, item.endY],
              scale: [1, 1.1, 0.2],
              opacity: [1, 1, 0.6]
            }}
            transition={{ duration: 0.7, ease: 'easeIn' }}
            onAnimationComplete={() => removeItem(item.id)}
          />
        ))}
      </AnimatePresence>
    </div>
  )
}

export default FlyToCartLayer